var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4,5a1,1,0,0,1-.707-.293l-3-3A1,1,0,0,1,1.707.293L4,2.586,6.293.293A1,1,0,0,1,7.707,1.707l-3,3A1,1,0,0,1,4,5Z",
  transform: "translate(7.768 9.5)"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.e08d20de.svg";
export { ForwardRef as ReactComponent };